export default __webpack_public_path__ + "static/media/grand-master-yang-form.f5c692e8.png";